import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { openPopup } from "../../store/popupSlice";
import Breadcrumb from "../../component/Breadcrumb";

const breadcrumbData = {
  newClass:"",
  list:[
    {
      page:"Home",
      slug:"/"
    },
    {
      page:"Car Rental Software",
      slug:""
    },
  ]
}

export default function CarRentalSubhead({featureId}) {
  const dispatch = useDispatch();
  return (
    <section className="header-gap car-rental-subhead">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="rental-subhead-wrap">
              <Breadcrumb breadcrumbData={breadcrumbData}/>
              {/* <label>CAR RENTAL SOFTWARE</label> */}
              <h1 className="heading">
                Expand Your Business with the
                <span> Best Car Rental Software.</span>
              </h1>
              <p>
                Mobility Infotech provides a powerful solution tailored for
                efficiently managing your car rental business. Whether you're a
                small business seeking car rental software or a growing
                enterprise in need of advanced car rental management software,
                we deliver tools designed for success. From seamless car rental
                booking software to comprehensive car rental company software,
                our solutions ensure your business thrives in every aspect.
              </p>
              <small>21 Days Free Trial | No Credit Card Required</small>
              <Link
                onClick={() => dispatch(openPopup())} className="default-btn animated-btn">
                Request demo
              </Link>

              <Link style={{marginLeft:"10px"}} to={`/features/${featureId}`} className= "default-btn animated-btn">
              Explore Features
            </Link>
            </div>
          </div>

          <div className="col-lg-6">
            <img
              src="./assets/home/car-rental-subhead.webp"
              alt="head"
              className="img-responsive subhead-main-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
